import { useState } from 'react';
import { CoverageEditDialog } from '@components/dialogs/CoverageEditDialog';
import { CoverageTable } from '@components/tables/CoverageTable';
import { DefaultDesignBar } from '@components/DefaultDesignBar';
import { usePaginate } from '@hooks/usePaginate';
import { OrangeButton } from '@components/buttons/OrangeButton';
import { coverageFilter } from '@utils/filters';
import { useLoadDesignData } from '@hooks/useLoadDesignData';

import type { Coverage } from '@features/redux/slices/designSlice';

const ITEMS_PER_PAGE = 10;

export const Coverages = () => {
    const { coverages, loadCoverages, loadingCoverage } = useLoadDesignData();

    const [editOpen, setEditOpen] = useState(false);
    const [selectedCoverage, setSelectedCoverage] = useState<Coverage>();

    const [searchText, setSearchText] = useState('');
    const [pageNumber, setPageNumber] = useState(1);

    const [pagedItems, pageCount] = usePaginate({
        filter: coverageFilter,
        items: coverages,
        itemsPerPage: ITEMS_PER_PAGE,
        searchText,
        pageNumber,
    });

    const search = (searchText: string) => {
        setSearchText(searchText);
        setPageNumber(1);
    };

    const selectPage = (page: number) => {
        setPageNumber(page);
    };

    const openEditDialog = (coverage?: Coverage) => {
        setEditOpen(true);
        setSelectedCoverage(coverage);
    };

    const closeDialog = (updatedData: boolean) => {
        setEditOpen(false);
        setSelectedCoverage(undefined);

        if (updatedData) {
            loadCoverages(true);
        }
    };

    return (
        <div style={{ marginTop: '180px' }}>
            <DefaultDesignBar selectedRoute={'coverages'} onSearch={search}>
                <OrangeButton onClick={() => openEditDialog()}>+ Coverage</OrangeButton>
            </DefaultDesignBar>

            <CoverageTable
                selectCoverage={openEditDialog}
                selectPage={selectPage}
                loadingCoverage={loadingCoverage}
                coverages={pagedItems as Coverage[]}
                pageCount={pageCount}
                pageNumber={pageNumber}
            />

            {editOpen && <CoverageEditDialog coverage={selectedCoverage} cancel={closeDialog} />}
        </div>
    );
};
